import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import styles from "../../../styles/SuccessPayment.module.scss";
import { useSelector } from "react-redux";
import labels from "../../../json/fallbackglobalvariables.json";

const SuccessPayment = () => {
    const customerSummary = useSelector((state) => state.login.customerInfo);
  
  
  const [paymentData, setPaymentData] = useState([]);
  const label = labels.acc;
  const [cardIcon,setCardIcon] =useState()
  
   const getCardIcon = () => {
        let className = '';
           
        const card = paymentData[0]?.successData?.data
        const brand = card?.servcDesc ?? card?.cardType ?? card?.accTypOfCcd ?? "Card";
        if (card?.pccCashType === 'ACH' || card?.pccCashSubType === 'CHK') {
            className = 'Checking';
        } else if (card?.pccCashType !== 'ACH' && card?.pccCashSubType !== 'CHK') {
            switch (card?.pccCashSubType) {
                case 'AMX':
                    className = 'AmericanExpress';
                    break;
                case 'DCV':
                    className = 'DiscoverCard';
                    break;
                case 'MCD':
                    className = 'Mastercard';
                    break;
                case 'VIS':
                    className = 'Visa';
                    break;
                default:
                    className = brand.toLowerCase().replace(/\s+/g, '-');
            }
        } else {
            className = brand.toLowerCase().replace(/\s+/g, '-');
        }
        return className;
    };
  useEffect(() => {
    const stored = JSON.parse(sessionStorage.getItem("paymentlist"));
    setPaymentData(stored || []);

    // ✅ Replace {EMAIL} placeholder in successNote
    if (typeof label.successNote === "string") {
      label.successNote = label.successNote.replace(
        "{EMAIL}",
        customerSummary?.[0]?.EmailAddress || ""
      );
    }

    return () =>{
      sessionStorage.removeItem("paymentlist");
    }
  }, []);

  useEffect(() => {
    if(paymentData.length){
      setCardIcon(getCardIcon())
    }
  },[paymentData]);

  const handlePrint = () => {
    window.print();
  };

  return (
   <div className={styles.componentWrapper}>
      <div className={styles.successBlock}>
        <div className={styles.sectionTitle}>
          <h2 className={styles.bgGreen}>{label.congratulations}</h2>
        </div>
        <img
          src="/images/check-circle-solid.svg"
          alt="Success"
          className={styles.successIcon}
        />
        <div className={styles.sectionSubtitle}></div>
        <span
          dangerouslySetInnerHTML={{
            __html: label.successMsg,
          }}
        />
        <strong>{paymentData[0]?.successData?.confirmation}</strong>.
      </div>

      <div className={styles.planList}>
        {paymentData[0]?.listData.map((val) => (
          <div className={styles.planSummary} key={val.id}>
            <div className={styles.planRow}>
              <div className={styles.planName}>{val.name}</div>
              <div className={styles.paymentMethod}>
                <b>{label.paymentMethod}</b>
                 <div className={`col-12 col-md-2 col-sm-4 ${styles["mb-10"]} ${styles["mb-md-0"]} ${styles["dblock"]}`}>
                    <div className={`${styles["mma--payment-method"]} ${styles[cardIcon] || cardIcon}`} />
                </div>

                {paymentData[0]?.successData?.data?.pccAcctLast4 && (
                  <span className={styles.lastDigits}>
                    Ending in {paymentData[0].successData?.data?.pccAcctLast4}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.enrolled}>{label.successNote}</div>

      <div className={styles.row}>
        <Link
          to="/my-account/payments"
          className={`${styles.btn} ${styles.btnGray} ${styles.btnLarge}`}
          aria-label="Return to payments"
        >
          {label.returnPaymentText}
        </Link>

        <button
          type="button"
          onClick={handlePrint}
          className={`${styles.btn} ${styles.btnOrange} ${styles.btnLarge} ${styles.printBtn}`}
          aria-label="Print for your records"
        >
          {label.printRecordText}
        </button>
      </div>
    </div>
  );
};

export default SuccessPayment;
